// extracted by mini-css-extract-plugin
export default {"tooltip":"SizeTooltip_tooltip__VOwh6"};